import { useState } from "react";

import { EditIcon, TroubleshootIcon } from "@dotnet/telematics-design-system";

import { VehicleDataDto } from "../../../../../Pages/Vehicles/interfaces";
import { VEHICLES_ACTIONS } from "../../../../../shared";
import { useDialog } from "../../../../PageHeader/actions/hooks";

const useVehicleInlineActions = () => {
  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  const [rowData, setRowData] = useState<VehicleDataDto | null>(null);
  const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

  const openEditDialog = (data: VehicleDataDto) => {
    setRowData(data);
    setIsEditOpen(true);
  };

  const closeEditDialog = () => {
    setRowData(null);
    setIsEditOpen(false);
  };

  const handleEditVehicleClick = (data: VehicleDataDto) => {
    openEditDialog(data);
  };

  const handleDownloadStatusClick = (data: any) => {
    setRowData(data);
    openDialog(VEHICLES_ACTIONS.DownloadMonitoring);
  };

  const handleCloseDownloadStatusDialog = () => {
    closeDialog(VEHICLES_ACTIONS.DownloadMonitoring);
    setRowData(null);
  };

  const inlineActions = [
    {
      title: VEHICLES_ACTIONS.DownloadMonitoring,
      icon: <TroubleshootIcon />,
      clickAction: (data: any) => handleDownloadStatusClick(data),
      renderConditions: () => true
    },
    {
      title: VEHICLES_ACTIONS.EditVehicle,
      icon: <EditIcon />,
      clickAction: (data: any) => handleEditVehicleClick(data),
      renderConditions: () => true
    }
  ];

  return {
    inlineActions,
    rowData,
    isEditOpen,
    isDialogOpen,
    closeEditDialog,
    handleCloseDownloadStatusDialog
  };
};

export default useVehicleInlineActions;
